import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9vum56uxv5: FaireBrandEntity = {
  token: "b_9vum56uxv5",
  type: "brand",
  name: "JAEMI GOODS",
  avatarUrl:
    "https://cdn.faire.com/fastly/54c356fdccce280cfbb2be6a4463c9df92ab311b6f36097d31fb03c0335c3a90.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1158b2a8ba883debf7beefbd767ce1db220c8b2c7b7a65e845e456094a9e96ac.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/54c356fdccce280cfbb2be6a4463c9df92ab311b6f36097d31fb03c0335c3a90.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1158b2a8ba883debf7beefbd767ce1db220c8b2c7b7a65e845e456094a9e96ac.jpeg",
  location: "Virginia Beach, VA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "JAEMI GOODS is a “fun” inspired brand that brings playfulness to the home. We seek to incorporate fun, simple elements into everyday living with the purpose to bring smiles & joy to the world around us.\n\nJaemi (재미) comes from the Korean word for FUN - 재미.",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:07.026Z",
    importedBy: "entity-db-cli",
  },
};
